import { has, isArray, isPlainObject, values } from 'lodash'

/**
 * Returns whether the object has true values.
 * @param {object} object
 * @returns {bool} isEmpty
 */
export const hasTrueValues = (object, callback) => {
  return values(object).filter(o => o === true).length > 0
}

/**
 * Returns whether the object has all provided keys.
 * @param {object} o
 * @param {string|string[]} keys
 * @returns {boolean}
 */
export const isWellShaped = (o, keys) => {
  if (isPlainObject(o)) {
    if (isArray(keys)) {
      for (const k of keys) {
        if (!has(o, k)) {
          return false
        }
      }

      return true
    } else if (typeof keys === 'string') {
      if (has(o, keys)) {
        return true
      }
    } else {
      return true
    }
  }

  return false
}

/**
 * Map over object
 * @param {object} object
 * @returns {bool} isEmpty
 */
export const mapObject = (object, callback) => {
  if (typeof object === 'object' && typeof callback === 'function') {
    return Object.keys(object).map(key => callback(key, object[key]))
  } else {
    return
  }
}

const setPath = ([key, ...next], value, obj) => {
  if (next.length === 0) {
    return { ...obj, [key]: value }
  }
  return { ...obj, [key]: setPath(next, value, obj[key]) }
}

// Source: https://gist.github.com/maxired/abb945a832495f325e7dce205b7deb9c#file-minimal-set-js
export const set = (oPath, value, obj) => setPath(oPath.split('.'), value, obj)
